import RawMaterialHeader from "./Header";
import "./index.css";
import { useState, useEffect } from "react";
import ProdMaterialProcessContents from "./ProdMaterialProcessContents";
import ProdMaterialInputContents from "./ProdMaterialInputContents";
import { ShowHide } from "../components/ShowHideProduct";
import {
  getProductManufacturingTotal,
  createSystemBoundaryProductManufacturing,
} from "../../../../apis/Product/ProductManufacturingTotalApi";
import {
  getProductManufacturingProcessTotal,
  createSystemBoundaryProductManufacturingProcess,
} from "../../../../apis/Product/ProductManufacturingProcessTotalApi";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdManufacturingComponents = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const [totalProdItem, setTotalProdItem] = useState([]);
  const [systemBoundaryItem, setSystemBoundaryItem] = useState("");
  const [systemBoundaryProcess, setSystemBoundaryProcess] = useState("");

  useEffect(() => {
    getProductManufacturingTotal({
      id: productId,
      setProdInv: setTotalProdItem,
      setSystemBoundary: setSystemBoundaryItem,
    });
    getProductManufacturingProcessTotal({
      id: productId,
      setSystemBoundary: setSystemBoundaryProcess,
    });
  }, [productId]);

  return (
    <div className="prod-manufacturing-container" id="prod-manufacturing-id">
      <RawMaterialHeader
        productId={productId}
        show={show}
        totalProdItem={totalProdItem}
      />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <ProdMaterialProcessContents
          productId={productId}
          systemBoundaryProps={{
            systemBoundary: systemBoundaryProcess,
            setSystemBoundary: setSystemBoundaryProcess,
            productId: productId,
            createSystemBoundaryFunc:
              createSystemBoundaryProductManufacturingProcess,
          }}
        />
      )}
      {show && (
        <ProdMaterialInputContents
          productId={productId}
          systemBoundaryProps={{
            systemBoundary: systemBoundaryItem,
            setSystemBoundary: setSystemBoundaryProcess,
            productId: productId,
            createSystemBoundaryFunc: createSystemBoundaryProductManufacturing,
            isManufacturing: true,
          }}
        />
      )}
    </div>
  );
};

export default ProdManufacturingComponents;
